import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Toaster } from "react-hot-toast";
import { GrnRoutes } from "../../data";
import { useGRNSummaryQuery } from "../../services/grnApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import ExportNav from "../Common/Nav/ExportNav";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";

function GRNSummary() {
  let i = 1;
  // Date

  const auth = signInUser();

  const { aamarId, storeSettings } = auth;
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [exportData, setExportData] = useState([]);
  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);
  const [warehouse, setWarehouse] = useState("allWh");
  const { data, isSuccess, isFetching, isLoading, refetch } =
    useGRNSummaryQuery({
      startDate,
      endDate,
      warehouse,
      aamarId,
    });
  const [totalGRN, setTotal] = useState(0);

  // console.log("GRN-DATA ::>", data);

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    setLoader(false);
    if (data?.products?.length > 0) {
      let total = 0;
      data.products.map((pro) => {
        // console.log(pro)
        total = total + parseFloat(pro.stockValue);
        // console.log(total)
      });
      setTotal(total);
      setExportData(data?.products);
    }
  }, [isSuccess, data]);
  // console.log(totalGRN);

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["GRN Summary Report"],

    [], // Empty row for spacing
  ];

  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Grn Summary by Article"></Header>
            <div className="row mt-3">
              <div className="col-md-5">
                {/* Sort date range */}
                <div className="date-picker mb-2">
                  <div className=" d-flex mb-2 align-items-center gap-2">
                    {/* <b>Start:</b> */}
                    <DatePicker
                      selected={new Date(startDate)}
                      className="form-control me-2"
                      onChange={(date) =>
                        setStartDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                    <DatePicker
                      selected={new Date(endDate)}
                      className="form-control"
                      onChange={(date) =>
                        setEndDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                  </div>
                  {/* warehouse */}
                  {auth?.type === "admin" && (
                    <div
                      className="mt-2 mt-md-0 mb-2 mb-md-0 "
                      style={{
                        width:
                          window.innerWidth >= 1024
                            ? 280
                            : window.innerWidth >= 768
                            ? 280
                            : "100%", // Adjust width based on screen size
                      }}
                    >
                      <WareHouseDW
                        id="warehouse"
                        name="warehouse"
                        handleOnChange={handleOnchangeWareHouseFrom}
                        className="form-control "
                      />
                    </div>
                  )}
                  {/* Search */}
                  {/* <input
                    className="form-control"
                    name="search"
                    type="Search"
                    onChange={(e) => setSearch(e.target.value)}
                  />*/}
                </div>
              </div>
              <div className="col-md-7">
                <span className="float-end">
                  <ExportNav
                    preheader={preHeader}
                    Routes={GrnRoutes}
                    data={exportData}
                    title="GRN Summary"
                  />
                </span>
              </div>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="">SL</th>
                  <th className="">Aricle Code</th>
                  <th>Article Name</th>
                  <th className="text-end">Avg MRP</th>
                  <th className="text-end">Avg TP</th>
                  <th className="ps-3">QTY</th>
                  <th className="text-center">Unit</th>
                  <th className="text-center">GRNno</th>
                  <th className="text-end">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {data?.products?.length > 0 ? (
                  data?.products?.map((grn) => (
                    <tr key={grn._id}>
                      <td>{i++}</td>
                      <td className="">{grn.article_code}</td>
                      <td>{grn.name}</td>
                      <td className="text-end">
                        {parseFloat(grn.mrp).toFixed(2)}
                      </td>
                      <td className="text-end">
                        {parseFloat(grn.tp)?.toFixed(2)}
                      </td>
                      <td className="ps-3">
                        <b>{parseFloat(grn.qty)?.toFixed(2)} </b>
                        {/* {`[${grn?.unit}]`} */}
                      </td>
                      <td className="text-center">{grn.unit}</td>
                      <td className="text-center">
                        {parseFloat(grn.grnQty)?.toFixed(2)}
                      </td>
                      <td className="text-end">
                        <b>
                          {new Intl.NumberFormat().format(
                            parseFloat(grn.stockValue)?.toFixed(2)
                          )}
                        </b>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr colSpan={9}>No Product Found</tr>
                )}
                <tr>
                  <td className="text-end" colSpan={8}>
                    <b>GRAND TOTAL:</b>
                  </td>
                  <td className="text-end">
                    <b>
                      {new Intl.NumberFormat().format(totalGRN)}
                      {/* {typeof data?.stockValue === "number"
                        ? new Intl.NumberFormat().format(data?.stockValue)
                        : 0} */}
                    </b>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <Toaster position="bottom-right" />
    </div>
  );
}

export default GRNSummary;
